


















import { HighlightsButtonMeta } from '@front-app/modules/group/highlights/model';
import { decodeContentSource } from '@front-app/modules/group/highlights/util/content';
import { Routes } from '@front-app/constants/routes';
import { CATEGORIES_ICON } from '@front-app/vendor/icon-definitions';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import BaseButtonRender from './BaseButtonRender.vue';

export default defineComponent({
	components: {
		BaseButtonRender,
	},
	props: {
		meta: {
			type: Object as PropType<HighlightsButtonMeta>,
			required: true,
		},
	},
	setup(props, ctx) {
		const toContentSearch = computed(() => {
			const {
				categories,
			} = decodeContentSource(props.meta.contentSource);
			const groupId = props.meta.groupId || ctx.root.$route.params.groupId;
			return {
				name: Routes.GROUP_CONTENT,
				params: {
					groupId,
				},
				query: {
					categories,
				},
			};
		});
		return {
			toContentSearch,
			iconProps: CATEGORIES_ICON,
		};
	},
});
